export default __webpack_public_path__ + "31e646ec30f2a3c3ecc0efe5bee9e874.svg";